import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IJadaiReceipt, IJadaiReceiptInitialState } from "./jadaiReceiptModel";
import {
  createJadaiReceipt,
  deleteJadaiReceipt,
  findAllJadaiReceipt,
  findByOrderNoJadaiReceipt,
  getAllOrderJadaiIssue,
  getJadaiReceiptById,
  updateJadaiReceipt,
} from "./services/jadaireceipt.services";

const initialState: IJadaiReceiptInitialState = {
  loading: false,
  error: "",
  JadaiReceiptID: null,
  JadaiReceiptList: [],
  JadaiReceiptDetail: {
    karigar_id: null,
    karigar_name: "",
    receipt_date: new Date(),
    jadai_receipt_order: [],
  },
  JadaiOrderList: [],
  FilterJadaiReceipt: {
    karigar_name: "",
    karigar_nick_name: "",
    receipt_date: "",
  },
  JadaiReceiptOrderItemIndex: -1,
  JadaiReceiptUsedItemIndex: -1,
  JadaiReceiptUsedItemDeleteConfirmDialog: false,
  JadaiReceiptOrderSelectionDialog: false,
  JadaiReceiptOrderSave: false,
  JadaiReceiptPreviousOrder: null,
  JadaiReceiptChecklistDialog: false,
  JadaiReceiptViewImageDialog: false,
};

const jadaiReceiptSlice = createSlice({
  name: "jadaireceipt",
  initialState,
  reducers: {
    clearJadaiReceiptDetail: (state) => {
      state.JadaiReceiptDetail = initialState.JadaiReceiptDetail;
    },
    setJadaiReceiptID: (state, action) => {
      state.JadaiReceiptID = action.payload;
    },

    setFilterJadaiReceipt: (state, action) => {
      state.FilterJadaiReceipt = action.payload;
    },
    setJadaiReceiptOrderSave: (state, action) => {
      state.JadaiReceiptOrderSave = action.payload;
    },
    clearFilterJadaiReceipt: (state) => {
      state.FilterJadaiReceipt = initialState.FilterJadaiReceipt;
    },
    setJadaiReceiptOrderItemIndex: (state, action) => {
      state.JadaiReceiptOrderItemIndex = action.payload;
    },
    setJadaiReceiptUsedItemIndex: (state, action) => {
      state.JadaiReceiptUsedItemIndex = action.payload;
    },
    setJadaiReceiptPreviousOrder: (state, action) => {
      state.JadaiReceiptPreviousOrder = action.payload;
    },

    openJadaiReceiptUsedItemDeleteConfirmDialog: (state) => {
      state.JadaiReceiptUsedItemDeleteConfirmDialog = true;
    },
    closeJadaiReceiptUsedItemDeleteConfirmDialog: (state) => {
      state.JadaiReceiptUsedItemDeleteConfirmDialog = false;
    },
    openJadaiReceiptOrderSelectionDialog: (state) => {
      state.JadaiReceiptOrderSelectionDialog = true;
    },
    closeJadaiReceiptOrderSelectionDialog: (state) => {
      state.JadaiReceiptOrderSelectionDialog = false;
    },
    openJadaiReceiptChecklistDialog: (state) => {
      state.JadaiReceiptChecklistDialog = true;
    },
    closeJadaiReceiptChecklistDialog: (state) => {
      state.JadaiReceiptChecklistDialog = false;
    },
    openJadaiReceiptViewImageDialog: (state) => {
      state.JadaiReceiptViewImageDialog = true;
    },
    closeJadaiReceiptViewImageDialog: (state) => {
      state.JadaiReceiptViewImageDialog = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(findAllJadaiReceipt.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      findAllJadaiReceipt.fulfilled,
      (state, action: PayloadAction<IJadaiReceipt[]>) => {
        state.loading = false;
        state.JadaiReceiptList = action.payload || [];
      },
    );
    builder.addCase(findAllJadaiReceipt.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.JadaiReceiptList = [];
    });

    builder.addCase(createJadaiReceipt.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createJadaiReceipt.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createJadaiReceipt.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(updateJadaiReceipt.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateJadaiReceipt.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateJadaiReceipt.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deleteJadaiReceipt.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteJadaiReceipt.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteJadaiReceipt.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getJadaiReceiptById.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getJadaiReceiptById.fulfilled, (state, action: any) => {
      state.loading = false;
      state.JadaiReceiptDetail = action.payload;
    });
    builder.addCase(getJadaiReceiptById.rejected, (state, action) => {
      state.loading = false;
      state.JadaiReceiptDetail = initialState.JadaiReceiptDetail;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(findByOrderNoJadaiReceipt.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(findByOrderNoJadaiReceipt.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(findByOrderNoJadaiReceipt.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getAllOrderJadaiIssue.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getAllOrderJadaiIssue.fulfilled, (state, action) => {
      state.loading = false;
      state.JadaiOrderList = action.payload || [];
    });
    builder.addCase(getAllOrderJadaiIssue.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.JadaiOrderList = initialState.JadaiOrderList;
    });
  },
});

export const {
  clearFilterJadaiReceipt,
  clearJadaiReceiptDetail,
  closeJadaiReceiptOrderSelectionDialog,
  closeJadaiReceiptUsedItemDeleteConfirmDialog,
  openJadaiReceiptOrderSelectionDialog,
  openJadaiReceiptUsedItemDeleteConfirmDialog,
  setFilterJadaiReceipt,
  setJadaiReceiptID,
  setJadaiReceiptOrderItemIndex,
  setJadaiReceiptUsedItemIndex,
  setJadaiReceiptOrderSave,
  setJadaiReceiptPreviousOrder,
  openJadaiReceiptChecklistDialog,
  closeJadaiReceiptChecklistDialog,
  openJadaiReceiptViewImageDialog,
  closeJadaiReceiptViewImageDialog,
} = jadaiReceiptSlice.actions;
export default jadaiReceiptSlice.reducer;
